import { isFunction } from 'lodash';

export const getPropAsFn = (prop, dft, ...params) => {
  const ret = isFunction(prop) ? prop(...params) : prop;
  return ret ?? dft;
};
